/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExecRiskRerunRequest
 */
export interface ExecRiskRerunRequest {
    /**
     * 
     * @type {string}
     * @memberof ExecRiskRerunRequest
     */
    process_id: string;
    /**
     * Reuse the process_id to run scans.
     * @type {boolean}
     * @memberof ExecRiskRerunRequest
     */
    reuse?: boolean;
}

/**
 * Check if a given object implements the ExecRiskRerunRequest interface.
 */
export function instanceOfExecRiskRerunRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "process_id" in value;

    return isInstance;
}

export function ExecRiskRerunRequestFromJSON(json: any): ExecRiskRerunRequest {
    return ExecRiskRerunRequestFromJSONTyped(json, false);
}

export function ExecRiskRerunRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskRerunRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'process_id': json['process_id'],
        'reuse': !exists(json, 'reuse') ? undefined : json['reuse'],
    };
}

export function ExecRiskRerunRequestToJSON(value?: ExecRiskRerunRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'process_id': value.process_id,
        'reuse': value.reuse,
    };
}

